export class OutboundSummaryMetricsByDay {
  type: string;
  inboundCallsTotal: number;
  completedCallsTotal: number;
  campaignSizeTotal: number;
  billableMinutesTotal: number;
  minutesSavedTotal: number;
  liveConnectionsTotal: number;
  appointmentsTotal: number;
  appointmentMinutesTotal: number;
  finalDispositionsTotal: number;
  wrongNumbersTotal: number;
  wrongNumberMinutesTotal: number;
  miscellaneousTotal: number;
  miscellaneousMinutesTotal: number;
  voicemailsTotal: number;
  avgCallTime: number;
  apppointmentsOSS: number;
  apppointmentsFollowup: number;
  customerToScheduleOnOwn: number;
  noLongerOwnsVehicle: number;
  alreadyComplete: number;
  leftMessage: number;
  unableToLeaveMessage: number;
  estimatedCosts: number;
  completedRate: number;
  liveConnectionRate: number;
  appointmentRate: number;
  voicemailRate: number;

  previousInboundCallsTotal: number;
  previousCompletedCallsTotal: number;
  previousCampaignSizeTotal: number;
  previousBillableMinutesTotal: number;
  previousMinutesSavedTotal: number;
  previousLiveConnectionsTotal: number;
  previousAppointmentsTotal: number;
  previousAppointmentMinutesTotal: number;
  previousFinalDispositionsTotal: number;
  previousWrongNumbersTotal: number;
  previousWrongNumberMinutesTotal: number;
  previousMiscellaneousTotal: number;
  previousMiscellaneousMinutesTotal: number;
  previousVoicemailsTotal: number;
  previousAvgCallTime: number;
  previousApppointmentsOSS: number;
  previousApppointmentsFollowup: number;
  previousCustomerToScheduleOnOwn: number;
  previousNoLongerOwnsVehicle: number;
  previousAlreadyComplete: number;
  previousLeftMessage: number;
  previousUnableToLeaveMessage: number;
  previousEstimatedCosts: number;
  previousCompletedRate: number;
  previousLiveConnectionRate: number;
  previousAppointmentRate: number;
  previousVoicemailRate: number;

  pageLength: number;
  pageNumber: number;
  totalRecords: number;
  records: OutboundSummaryMetricByDayRecord[];
};

export interface OutboundSummaryMetricByDayRecord {
  date: string;
  inboundCalls: number;
  completedCalls: number;
  campaignSize: number;
  billableMinutes: number;
  minutesSaved: number;
  liveConnections: number;
  appointments: number;
  appointmentMinutes: number;
  finalDispositions: number;
  wrongNumbers: number;
  wrongNumberMinutes: number;
  miscellaneous: number;
  miscellaneousMinutes: number;
  voicemails: number;
  avgCallTime: number;
  estimatedCosts: number;
  completedRate: number;
  liveConnectionRate: number;
  appointmentRate: number;
  voicemailRate: number;
  apppointmentsOSS: number;
  apppointmentsFollowup: number;
  customerToScheduleOnOwn: number;
  noLongerOwnsVehicle: number;
  alreadyComplete: number;
  leftMessage: number;
  unableToLeaveMessage: number;
};

export const EmptyOutboundSummaryMetricsByDay: OutboundSummaryMetricsByDay = {
  type: '',
  inboundCallsTotal: 0,
  completedCallsTotal: 0,
  campaignSizeTotal: 0,
  billableMinutesTotal: 0,
  minutesSavedTotal: 0,
  liveConnectionsTotal: 0,
  appointmentsTotal: 0,
  appointmentMinutesTotal: 0,
  finalDispositionsTotal: 0,
  wrongNumbersTotal: 0,
  wrongNumberMinutesTotal: 0,
  miscellaneousTotal: 0,
  miscellaneousMinutesTotal: 0,
  voicemailsTotal: 0,
  avgCallTime: 0,
  estimatedCosts: 0,
  completedRate: 0,
  liveConnectionRate: 0,
  appointmentRate: 0,
  voicemailRate: 0,
  apppointmentsOSS: 0,
  apppointmentsFollowup: 0,
  customerToScheduleOnOwn: 0,
  noLongerOwnsVehicle: 0,
  alreadyComplete: 0,
  leftMessage: 0,
  unableToLeaveMessage: 0,

  previousInboundCallsTotal: 0,
  previousCompletedCallsTotal: 0,
  previousCampaignSizeTotal: 0,
  previousBillableMinutesTotal: 0,
  previousMinutesSavedTotal: 0,
  previousLiveConnectionsTotal: 0,
  previousAppointmentsTotal: 0,
  previousAppointmentMinutesTotal: 0,
  previousFinalDispositionsTotal: 0,
  previousWrongNumbersTotal: 0,
  previousWrongNumberMinutesTotal: 0,
  previousMiscellaneousTotal: 0,
  previousMiscellaneousMinutesTotal: 0,
  previousVoicemailsTotal: 0,
  previousAvgCallTime: 0,
  previousEstimatedCosts: 0,
  previousCompletedRate: 0,
  previousLiveConnectionRate: 0,
  previousAppointmentRate: 0,
  previousVoicemailRate: 0,
  previousApppointmentsOSS: 0,
  previousApppointmentsFollowup: 0,
  previousCustomerToScheduleOnOwn: 0,
  previousNoLongerOwnsVehicle: 0,
  previousAlreadyComplete: 0,
  previousLeftMessage: 0,
  previousUnableToLeaveMessage: 0,

  pageLength: 0,
  pageNumber: 0,
  totalRecords: 0,
  records: []
};
